import { type FieldValues, useController } from 'react-hook-form';
import type {
  FormControlProps,
  TypedUseControllerProps,
} from '../FormControl/FormControl.types';
import {
  MultiSelectField,
  type MultiSelectFieldProps,
} from '../MultiSelectField/MultiSelectField';

export type FormMultiSelectProps<
  TFieldValues extends FieldValues = FieldValues,
  TValue extends string = string,
> = TypedUseControllerProps<TFieldValues, TValue[]> &
  FormControlProps<MultiSelectFieldProps<TValue>>;

export const FormMultiSelect = <
  TFieldValues extends FieldValues = FieldValues,
  TValue extends string = string,
>({
  disabled,
  ...props
}: FormMultiSelectProps<TFieldValues, TValue>) => {
  const {
    field: { ref, ...field },
    fieldState: { error: fieldError },
  } = useController(props);

  const hasError = props.hasError || fieldError !== undefined;

  return (
    <MultiSelectField
      {...props}
      {...field}
      disabled={disabled}
      hasError={hasError}
      inputRef={ref}
    />
  );
};
